
import { defineComponent } from "vue";
import { Field } from "vee-validate";

const TextField = defineComponent({
  name: "TextField",
  inheritAttrs: false,
  components: {
    Field,
  },
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    modelValue: {
      type: String,
      default: "",
    },
    typeInput: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    isError: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});
export default TextField;
